import { render, staticRenderFns } from "./Matrix4.vue?vue&type=template&id=febcb8d4&scoped=true"
import script from "./Matrix4.vue?vue&type=script&lang=js"
export * from "./Matrix4.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=febcb8d4&prod&scoped=true&lang=css&external"
import style1 from "./Matrix4.vue?vue&type=style&index=1&id=febcb8d4&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febcb8d4",
  null
  
)

export default component.exports